/**
 * Created by buddy on 2020-07-20.
 */
// @ts-nocheck
import { createReducer } from '@reduxjs/toolkit';

const initialState = {};

export default (state, action) => null;
